export function Margin(props) {
  return <div className="margin">{props.children}</div>;
}

export default Margin;
